"use strict";

// import { brotliDecompressSync } from "zlib";

///// menu -SEAB

Array.from(
	document.querySelectorAll(
		".paragraph--type--menus-internos > div:nth-child(1)"
	)
).map(function (cas, ind) {
	if (cas != null) {
		var siblings = !!cas.nextElementSibling ? true : false;

		if (siblings) {
			var newcaret = document.createElement("div");
			newcaret.classList.add("caret-seab");
			if (cas.children != null) {
				cas.children[0].insertAdjacentElement("afterend", newcaret);
			}
			cas.classList.add("father-menu-seab");

			newcaret.onclick = function () {
				var parent = this.closest(".paragraph--type--menus-internos"),
					mainContent = this.closest(".paragraph-menu-seab"),
					currentActive = mainContent.querySelector(".caret-seab-active");

				if (!!currentActive && currentActive !== parent)
					currentActive.classList.remove("caret-seab-active");
				parent.classList.toggle("caret-seab-active");
			};
		}
	}
});

/// enlaces- menu- SEAB

function getAbsolutePath() {
	var loc = window.location;
	var pathName = loc.pathname.substring(0, loc.pathname.lastIndexOf("/") + 1);
	return loc.href.substring(
		0,
		loc.href.length -
		((loc.pathname + loc.search + loc.hash).length - pathName.length)
	);
}

var URLactual = window.location;
var pathname = window.location.pathname;
var AbsolutePath = getAbsolutePath();

Array.from(
	document.querySelectorAll(
		".menu-drop-down .paragraph--type--menus-internos a"
	)
).map(function (en) {
	if (en != null) {
		var pru = en.getAttribute("href");
		if (
			(pru == URLactual || pru == pathname || AbsolutePath.includes(pru)) &&
			pru != null
		) {
			en.classList.add("link-active");
		}
	}
});

var link_blue = document.querySelector(
	".menu-drop-down .paragraph--type--menus-internos .link-active"
);
if (link_blue != null) {
	var father = link_blue.closest("div");
	var grand_father = link_blue.closest(".paragraph");
	father.classList.add("father-link");
	grand_father.classList.add("grand-father-link");
}

//// caret -menu- SEAB

Array.from(document.querySelectorAll(".father-menu-seab a")).map(function (cab) {
	if (cab != null && cab.classList.contains("link-active")) {
		cab.parentNode.parentNode.classList.add("caret-white");
	}
});

/// enlaces- menu- centro de info

var URLactual_center = window.location;
var pathname_center = window.location.pathname;
var AbsolutePath_center = getAbsolutePath();
Array.from(document.querySelectorAll("#ul-menu-quienes-somos li a")).map(
	function (e) {
		if (e != null) {
			var pru_center = e.getAttribute("href");
			if (
				(pru_center == URLactual_center ||
					pru_center == pathname_center ||
					AbsolutePath_center.includes(pru_center)) &&
				pru_center != null
			) {
				e.classList.add("is-active");
			}
		}
	}
);

/// js para evitar doble enlace azul menu

var URLactual_father = window.location;
var pathname_father = window.location.pathname;

Array.from(
	document.querySelectorAll("#ul-menu-quienes-somos .item-father > a")
).map(function (e) {
	if (e != null) {
		var pru_father = e.getAttribute("href");
		if (
			pru_father !== URLactual_father &&
			pru_father !== pathname_father &&
			pru_father != null
		) {
			e.classList.remove("is-active");
		}
	}
});

//// caret -menu- centro de informacion

setTimeout(function () {
	Array.from(document.querySelectorAll(".item-father > a")).map(function (ca) {
		if (ca != null && ca.classList.contains("is-active")) {
			ca.nextElementSibling.classList.add("caret-white");
		}
	});
}, 1000);

//acordeon documents ///////

var accItem = document.getElementsByClassName("views-row-group");
var accHD = document.getElementsByTagName("h2");
if (accHD != null && accItem != null) {
	var i = 0;
	for (i = 0; i < accHD.length; i++) {
		accHD[i].addEventListener("click", toggleItem, false);
	}
}

function toggleItem() {
	var itemClass = this.parentNode.className;
	for (i = 0; i < accItem.length; i++) {
		accItem[i].className = "views-row-group close";
	}
	if (itemClass == "views-row-group close") {
		this.parentNode.className = "views-row-group open";
	}
}

///////////HEADER

function myheader() {
	var box_header = document.querySelector(".navbar-brand");
	var Logo_header = document.querySelector(".is-pulled-left");
	var lupa_header = document.querySelector(".search-buttonl");
	var Logo_desktop = document.querySelector("#block-archdiocese-branding");
	var Lupa_desktop = document.querySelector(
		"#block-views-block-search-button-nav-block-1 .field-content"
	);
	var bloque_busqueda = document.querySelector(
		".block-views-exposed-filter-blockbuscador-arquidiocesis-general-page-1"
	);

	var width_header = window.innerWidth;

	if (width_header <= 1024) {
		if (
			box_header != null &&
			Logo_header != null &&
			lupa_header != null &&
			bloque_busqueda != null
		) {
			box_header.appendChild(Logo_header);
			box_header.appendChild(lupa_header);
			box_header.appendChild(bloque_busqueda);
		}
	} else {
		if (
			Logo_desktop != null &&
			Logo_header != null &&
			lupa_header != null &&
			Lupa_desktop != null
		) {
			Logo_desktop.appendChild(Logo_header);
			Lupa_desktop.appendChild(lupa_header);
		}
	}

	/// shadow -home -seab

	var width_slider_seab = window.innerWidth;

	if (width_slider_seab <= 1024) {
		Array.from(
			document.querySelectorAll(".swiper-SEAB .content-slider-seab")
		).map(function (swa) {
			if (swa != null) {
				var lo = swa.children.length;
				if (lo == 0) {
					swa.style.background = "#333333";
				}
			}
		});
	} else {
		Array.from(
			document.querySelectorAll(".swiper-SEAB .content-slider-seab")
		).map(function (swa) {
			if (swa) {
				var lo = swa.children.length;
				if (lo == 0) {
					swa.style.background = "transparent";
				}
			}
		});
	}
}
myheader();

////////// PAGE VATICAN

var text_vatican = document.querySelector(
	".block-views-blockdocumentos-del-vaticano-block-2 .block-entity-fieldnodecaption"
);
var social_media_vatican = document.querySelector(
	".block-views-blockdocumentos-del-vaticano-block-2 .container-content__network"
);
var contaienr_vatican = document.querySelector(
	".block-views-blockdocumentos-del-vaticano-block-2 .section-news--container"
);
if (
	text_vatican != null &&
	social_media_vatican != null &&
	contaienr_vatican != null
) {
	contaienr_vatican.appendChild(text_vatican);
	contaienr_vatican.appendChild(social_media_vatican);
}

////////// PAGE CANONIZATIONS

var text_canonization = document.querySelector(
	".block-views-blocktaxonomia-categorias-primer-bloque-block-2   .block-entity-fieldnodecaption"
);
var social_media_canonization = document.querySelector(
	".block-views-blocktaxonomia-categorias-primer-bloque-block-2 .container-content__network"
);
var container_canonization = document.querySelector(
	".block-views-blocktaxonomia-categorias-primer-bloque-block-2 .section-news--container"
);
if (
	text_canonization != null &&
	social_media_canonization != null &&
	container_canonization != null
) {
	container_canonization.appendChild(text_canonization);
	container_canonization.appendChild(social_media_canonization);
}

//// prueba sumoselect
(function ($) {
	Array.from(
		document.querySelectorAll(
			".block-views-blocklanding-eventos-block-2 select"
		)
	).map(function (el) {
		if (el != null) {
			el.classList.add("testselect1");
			$(".testselect1").SumoSelect({
				forceCustomRendering: true,
				floatWidth: 300
			});
		}
	});

	//// sumoselect boletin virtual
	Array.from(document.querySelectorAll(".virtual-newsletter select")).map(
		function (el) {
			if (el != null) {
				el.classList.add("testselect1");
				el.classList.add("testselect-virtual");
				$(".testselect1").SumoSelect({
					forceCustomRendering: true,
					floatWidth: 300
				});
			}
		}
	);

	//// sumoselect boletin virtual
	Array.from(
		document.querySelectorAll(".form-item-field-arciprestazgo-target-id select")
	).map(function (el) {
		if (el != null) {
			el.classList.add("testselect1");
			el.classList.add("testselect-arci");
			$(".testselect1").SumoSelect({
				forceCustomRendering: true,
				floatWidth: 300
			});
		}
	});
})(jQuery);



////////// PAGINATION-LANDING-NOTICES

var pagination_landing = document.querySelector(
	".news-general-numerous .pagination"
);
var news_general_numerous = document.querySelector(".news-general-numerous");
if (pagination_landing != null && news_general_numerous != null) {
	news_general_numerous.appendChild(pagination_landing);
}
////////// PAGINATION-GALLERY-SEAB

var pagination_gallery = document.querySelector(
	".block-views-blockgalerias-minisitio-tipo-2-block-6 .pagination"
);
var block_other_galleries = document.querySelector(
	".block-views-blockgalerias-minisitio-tipo-2-block-6"
);
if (pagination_gallery != null && block_other_galleries != null) {
	block_other_galleries.appendChild(pagination_gallery);
}

////// caret menus mobile SEAB

var container_menu_seab = document.querySelector(".paragraph-menu-seab");

if (container_menu_seab != null) {
	var title_menu_seab = document.querySelector(
		".paragraph-menu-seab > div:nth-child(1) div"
	);
	var newcaret_title = document.createElement("div");
	newcaret_title.classList.add("caret-seab-menu");
	title_menu_seab.insertAdjacentElement("afterend", newcaret_title);
	title_menu_seab.parentElement.classList.add("father-menu-mobile");

	var drop_down_menu = document.querySelector(".father-menu-mobile");
	var switch_section_menu = 0;

	if (drop_down_menu != null) {
		drop_down_menu.addEventListener("click", function () {
			if (switch_section_menu == 0) {
				container_menu_seab.classList.add("menu--active");
				switch_section_menu = 1;
			} else {
				container_menu_seab.classList.remove("menu--active");
				switch_section_menu = 0;
			}
		});
	}
}

//// script para fecha de evento en buscador

Array.from(document.querySelectorAll(".search-result-item .tipo")).map(function (
	evt
) {
	var event_date = evt.closest(".search-result-item");
	if (evt != null && evt.innerText == "Evento" && event_date != null) {
		event_date.querySelector(".date-share-create").style.display = "none";
	}
});

/// script para bloque de publicidad

Array.from(document.querySelectorAll(".block-ads-block")).map(function(e) {
  if (
	e.firstChild.innerText === "Mobile" ||
	e.firstChild.innerText === "Desktop"
  ) {
	if (
	  e.firstChild != null &&
	  e.firstChild.innerText == "Desktop" &&
	  e != null
	) {
	  e.classList.add("Desktop-show");
	} else if (
	  e.firstChild != null &&
	  e.firstChild.innerText == "Mobile" &&
	  e != null
	) {
	  e.classList.add("Mobile-show");
	}
  } else {
	e.style.display = "none";
  }
});


/// script acordeon

Array.from(document.querySelectorAll(".plane-container")).map(function (e) {
	if (e != null) {
		e.addEventListener("click", function () {
			this.classList.toggle("active");
		});
	}
});


/// js para concatenar enlaces

Array.from(document.querySelectorAll(".links-father-concat")).map(function (e) {
	if (e != null) {
		var link1 = e.querySelector(".link-part-1"); 
		var link2 = e.querySelector(".link-part-2 span");

		if (link1 != null && link2 != null ) {
			var concat = `${link1.innerText}${link2.innerText}`;
			Array.from(e.querySelectorAll(".link-join")).map(function (ev) {
				if(ev != null && concat != null){
					ev.setAttribute("href", concat);
				}
			});
		}
		
	}
});



////// Pagina 404

var error_404 = document.querySelector(".error-404");
var container_basic_page = document.querySelector(".main-content");

if (error_404 != null && container_basic_page != null) {
	container_basic_page.classList.add("remove_networks");
}

////// Js header minisitio 1
function header_minisites() {
	var header_parish = document.querySelector(".header-minisite-one");
	var width_h = window.innerWidth;
	if (header_parish != null && width_h <= 1024) {
		var container_h = document.querySelector(".first-navbar .container");
		var icon_h = document.querySelector(
			".views-field-field-secondary-menu .icon"
		);
		var logo_h = document.querySelector(
			"#block-views-block-minisitio-tipo-1-menus-y-logo-block-4"
		);
		var lupa_h = document.querySelector("#search-button-nav");
		var navbar = document.querySelector(".navbar-brand");
		if ((container_h, icon_h, logo_h, lupa_h, navbar != null)) {
			container_h.appendChild(logo_h);
			navbar.insertBefore(view_parish, lupa_h);
			lupa_h.appendChild(icon_h);
		}
	}
}

var view_parish = document.querySelector(
	".block-views-blockminisitio-tipo-1-menus-y-logo-block-3 .logo-arqui-movil-parroquias"
);
var container_header = document.querySelector(".navbar.has-shadow");
if (view_parish != null && container_header != null) {
	container_header.classList.add("header-minisite-one");
	header_minisites();
}

////// Js header minisitio 2

function header_minisites_2() {
	var header_parish_2 = document.querySelector(".header-minisite-two");
	var width_h_2 = window.innerWidth;
	if (header_parish_2 != null && width_h_2 <= 1024) {
		// validar else para 1024 header
		var container_h_2 = document.querySelector(".first-navbar .container");
		var icon_h_2 = document.querySelector(
			".block-views-blockminisitio-tipo-2-menus-y-logo-block-2 .icon"
		);
		var logo_h_2 = document.querySelector(
			"#block-views-block-minisitio-tipo-2-menus-y-logo-block-4"
		);
		var lupa_h_2 = document.querySelector("#search-button-nav");
		var navbar_2 = document.querySelector(".navbar-brand");
		if ((container_h_2, icon_h_2, logo_h_2, lupa_h_2, navbar_2 != null)) {
			container_h_2.appendChild(logo_h_2);
			navbar_2.insertBefore(view_parish_2, lupa_h_2);
			lupa_h_2.appendChild(icon_h_2);
		}
	}
}

var view_parish_2 = document.querySelector(
	".block-views-blockminisitio-tipo-2-menus-y-logo-block-3"
);
var view_parish_menu_2 = document.querySelector(
	".block-views-blockminisitio-tipo-2-menus-y-logo-block-1"
);
var container_header_2 = document.querySelector(".navbar.has-shadow");
if (
	view_parish_2 != null &&
	container_header_2 != null &&
	view_parish_menu_2 != null
) {
	container_header.classList.add("header-minisite-one");
	container_header.classList.add("header-minisite-two");
	header_minisites_2();
}

////// Js header minisitio 3

function header_minisites_3() {
	var header_parish_3 = document.querySelector(".header-minisite-three");
	var width_h_3 = window.innerWidth;
	if (header_parish_3 != null && width_h_3 <= 1024) {
		var container_h_3 = document.querySelector(".first-navbar .container");
		var icon_h_3 = document.querySelector(
			".block-views-blockminisitio-tipo-3-menus-y-logo-block-2 .icon"
		);
		var logo_h_3 = document.querySelector(
			"#block-views-block-minisitio-tipo-3-menus-y-logo-block-4"
		);
		var lupa_h_3 = document.querySelector("#search-button-nav");
		var navbar_3 = document.querySelector(".navbar-brand");
		if ((container_h_3, icon_h_3, logo_h_3, lupa_h_3, navbar_3 != null)) {
			container_h_3.appendChild(logo_h_3);
			navbar_3.insertBefore(view_parish_3, lupa_h_3);
			lupa_h_3.appendChild(icon_h_3);
		}
	}
}

var view_parish_3 = document.querySelector(
	"#block-views-block-minisitio-tipo-3-menus-y-logo-block-3"
);
var view_parish_menu_3 = document.querySelector(
	"#block-views-block-minisitio-tipo-3-menus-y-logo-block-1"
);
var container_header_3 = document.querySelector(".navbar.has-shadow");
if (
	view_parish_3 != null &&
	container_header_3 != null &&
	view_parish_menu_3 != null
) {
	container_header.classList.add("header-minisite-one");
	container_header.classList.add("header-minisite-two");
	container_header.classList.add("header-minisite-three");
	header_minisites_3();
}

// HOME FINDER

var bloque_buscar = document.querySelector(
	".block-views-exposed-filter-blockbuscador-arquidiocesis-general-page-1"
);
var boton_lupa = document.getElementById("search-button-nav");
var cuerpo_lupa = document.getElementById(
	"block-views-block-search-button-nav-block-1"
);

var header_ubication = document.querySelector(".header-minisite-one");


if (bloque_buscar != null && boton_lupa != null && header_ubication === null) {
	boton_lupa.addEventListener("click", function (e) {
		cuerpo_lupa.classList.toggle("button-nav-active");
		boton_lupa.classList.toggle("search-button-active");
		bloque_buscar.classList.toggle('show-block-search'); 
	});
}


///// modal boletin virtual -videos

Array.from(
	document.querySelectorAll(".modal-play .container-content__video")
).map(function (e) {
	if (e != null) {
		e.addEventListener("click", function () {
			var title_modal = e.nextElementSibling;
			var video_modal = title_modal.nextElementSibling;

			var modal_course = document.querySelector(".modal-good-course");

			if (video_modal != null && title_modal != null && modal_course != null) {
				var prime_title = title_modal.cloneNode(true);
				var prime = video_modal.cloneNode(true);

				modal_course.classList.add("active-modal");

				var modal_container = document.querySelector(
					".modal-good-course .video "
				);
				var title_container = document.querySelector(
					".modal-good-course .title "
				);
				var close_modal_play = document.querySelector(
					".modal-good-course .close"
				);
				if (
					modal_container != null &&
					close_modal_play != null &&
					title_container != null
				) {
					title_container.appendChild(prime_title);
					modal_container.appendChild(prime);

					close_modal_play.addEventListener("click", function () {
						modal_course.classList.remove("active-modal");
						prime.remove();
						prime_title.remove();
					});
				}
			}
		});
	}
});

/// alto para galeria
Array.from(document.querySelectorAll(".block-views-four .galleries")).map(
	function (evt) {
		var container_right = document.querySelector(
			".container-lateral-right .galleries"
		);
		if (evt != null && container_right === null) {
			evt.classList.add("alto");
		}
	}
);

///// buscador movil minisitios

var width_search = window.innerWidth;
var container_search = document.querySelector(".mobile-search .search");
var results_search = document.querySelector(
	".mobile-search .search-result-item"
);

if (
	width_search <= 1024 &&
	results_search != null &&
	container_search != null
) {
	container_search.classList.add("search-next");
} else {
	if (container_search) {
		container_search.classList.remove("search-next");
	}
}

///// js after menu

var link_menu_after = document.querySelector(".nav .has-dropdown > a");
var father_menu_after = document.querySelector(
	".nav .navbar-item.has-dropdown"
);
var width_menu_after = window.innerWidth;

if (
	width_menu_after <= 1024 &&
	link_menu_after != null &&
	father_menu_after != null
) {
	father_menu_after.addEventListener("click", function (e) {
		if (e.offsetX > link_menu_after.offsetWidth) {
			father_menu_after.classList.toggle("active");
		}
	});
}

// js target

Array.from(document.querySelectorAll(".file a")).map(function (e) {
	if (e != null) {
		e.setAttribute("target", "_blank");
	}
});

// js target social networks

Array.from(document.querySelectorAll(".redes-paragraph a")).map(function (e) {
	if (e != null) {
		e.setAttribute("target", "_blank");
	}
});

// js target yo quiero

Array.from(document.querySelectorAll(".menu-icon-links .icon-link-item a")).map(
	function (e) {
		if (e != null) {
			e.setAttribute("target", "_blank");
		}
	}
);

/// js remove links vacios

Array.from(document.querySelectorAll(".links-remove .field-content")).map(
	function (e) {
		if (e != null) {
			if (e.firstElementChild != null) {
				console.log("good");
			} else {
				e.closest(".links-remove").remove();
			}
		}
	}
);

// js imagenes en link de cuerpo

Array.from(document.querySelectorAll(".body-article-internal a.file img")).map(
	function (e) {
		if (e != null) {
			e.parentElement.classList.add("file-img");
		}
	}
);

/// js remove menu minisite two

var menu_minisite_two = document.querySelector(
	".block-canonizations div.menu-drop-down"
);
if (menu_minisite_two != null) {
	var menu_content_two = menu_minisite_two.querySelector(
		".paragraph-menu-seab"
	);
	if (menu_content_two != null) {
		if (menu_content_two.innerText !== "") {
			var list_menu_two = menu_minisite_two.querySelector(".father-menu-mobile")
				.nextElementSibling;
			var title_menu_two = menu_minisite_two.querySelector(
				".father-menu-mobile .paragraph--type--enalces-hijos"
			);
			if (list_menu_two === null && title_menu_two != null) {
				if (title_menu_two.innerText === "")
					menu_minisite_two.parentElement.classList.add("remove-menu");
			}
		} else if (menu_content_two.innerText === "") {
			menu_minisite_two.parentElement.classList.add("remove-menu");
		}
	}
}

// js  para menu en minisitio tipo 2 en paginas basicas

var menu_minisite_two = document.querySelector(
	".block-canonizations div.menu-drop-down"
);
if (menu_minisite_two != null) {
	var menu_content_two = menu_minisite_two.querySelector(
		".views-field-field-menu-quienes-somos .field-content"
	);
	if (menu_content_two != null) {
		if (menu_content_two.innerText !== "") {
			var list_menu_two = menu_minisite_two.querySelector(".father-menu-mobile")
				.nextElementSibling;
			var title_menu_two = menu_minisite_two.querySelector(
				".father-menu-mobile .paragraph--type--enalces-hijos"
			);
			if (list_menu_two === null && title_menu_two != null) {
				if (title_menu_two.innerText === "")
					menu_minisite_two.parentElement.classList.add("remove-menu");
			}
		} else if (menu_content_two.innerText === "") {
			menu_minisite_two.parentElement.classList.add("remove-menu");
		}
	}
}

var menu_minisite_two = document.querySelector(
	".block-canonizations div.menu-drop-down"
);
if (menu_minisite_two != null) {
	var menu_content_two = menu_minisite_two.querySelector(
		".views-row .field-content"
	);
	if (menu_content_two != null) {
		if (menu_content_two.innerText !== "") {
			var list_menu_two = menu_minisite_two.querySelector(".father-menu-mobile")
				.nextElementSibling;
			var title_menu_two = menu_minisite_two.querySelector(
				".father-menu-mobile .paragraph--type--enalces-hijos"
			);
			if (list_menu_two === null && title_menu_two != null) {
				if (title_menu_two.innerText === "")
					menu_minisite_two.parentElement.classList.add("remove-menu");
			}
		} else if (menu_content_two.innerText === "") {
			menu_minisite_two.parentElement.classList.add("remove-menu");
		}
	}
}

// js remove menu completo en pagina de procesos

var proce = document.querySelector("#block-consultadeprocesos");
var menu_proce = document.querySelector(".block-canonizations");
if (proce != null && menu_proce != null) {
	menu_proce.classList.add("remove-menu-complete");
}

// js remove estructuras de links yo quiero vacios

var structure = document.querySelector(
	".paragraph--view-mode--minisite-one .menu-icon-links__title"
);
if (structure != null) {
	if (structure.innerText === "" && structure.nextElementSibling != null) {
		var item_stru = structure.nextElementSibling.querySelector(".ds-1col");
		if (item_stru != null) {
			if (item_stru.innerText === "") structure.parentElement.remove();
		}
	} else if (
		structure.innerText === "" &&
		structure.nextElementSibling === null
	) {
		structure.parentElement.remove();
	}
}

// js titulos bloques procesos

window.onload = function () {
	// js titulos bloques procesos
	Array.from(document.querySelectorAll(".block-process h2")).map(function (e) {
		var h2_block = document.querySelector(".title-block");
		if (e != null && h2_block != null) {
			h2_block.innerHTML += "<li>" + e.innerText + "</li>";
		}
	});

	// js para cambio de titulos tab en Procesos tribunal

	var h2_block_cambio = document.querySelector(".title-block");
	if (h2_block_cambio != null && h2_block_cambio.children.length > 1) {
		h2_block_cambio.firstElementChild.addEventListener("click", function () {
			if (h2_block_cambio.parentElement.classList.contains("proceso-dos")) {
				h2_block_cambio.parentElement.classList.remove("proceso-dos");
				h2_block_cambio.parentElement.classList.add("proceso-uno");
			} else {
				h2_block_cambio.parentElement.classList.add("proceso-uno");
			}
		});
		h2_block_cambio.lastElementChild.addEventListener("click", function () {
			if (h2_block_cambio.parentElement.classList.contains("proceso-uno")) {
				h2_block_cambio.parentElement.classList.remove("proceso-uno");
				h2_block_cambio.parentElement.classList.add("proceso-dos");
			} else {
				h2_block_cambio.parentElement.classList.add("proceso-dos");
			}
		});
	}
};

/// js dentro del AJAX de  los resultados de proceso

(function ($, Drupal) {
	Drupal.behaviors.auto = {
		attach: function (context, settings) {
			// js clase al mostrar reultados en procesos

			Array.from(document.querySelectorAll(".container-results")).map(function (
				e
			) {
				var bloque_group = document.querySelector(".groupconsulta-de-procesos");
				if (bloque_group != null && e != null) {
					if (e.children.length > 1) {
						bloque_group.classList.add("result-process");
					}
				}
			});

			// js boton recarga ventana en procesos

			var restart = document.querySelector(".container-results button.cancel");
			if (restart != null) {
				restart.addEventListener("click", function () {
					location.reload();
				});
			}
		}
	};
})(jQuery, Drupal);

//# sourceMappingURL=drop_down.arquidiocesis.script.js.map
